import React from "react";

import config from "../../config";
import {
  Modal,
  Button,
} from "antd";
import { PrinterOutlined } from "@ant-design/icons";


import axios from "axios";

const BASE_API = config.BASE_API;

const formatarMensagem = (texto = "") => {
  // quebra por linhas
  const linhas = texto.split("\n").filter(Boolean);

  return linhas.map((linha, index) => {
    // lista
    if (linha.trim().startsWith("·") || linha.trim().startsWith("-")) {
      return (
        <li key={index} style={{ marginBottom: 6 }}>
          {linha.replace(/^[-·]\s*/, "")}
        </li>
      );
    }

    // parágrafo
    return (
      <p key={index} style={{ marginBottom: 12, lineHeight: "1.6" }}>
        {linha}
      </p>
    );
  });
};

const BloqueioJuntaMedica = ({ visivel, mensagem, onFechar }) => {

  const handleImprimir = async () => {
    try {
      const response = await axios.get(
        `${BASE_API}relatorios/termo-bloqueio-junta-medica`,
        {
          responseType: "blob",
        }
      );
  
      const file = new Blob([response.data], {
        type: "application/pdf",
      });
  
      const fileURL = URL.createObjectURL(file);
  
      // Abre SOMENTE em outra aba (sem disparar impressão)
      window.open(fileURL, "_blank");
  
    } catch (error) {
      console.error(error);
    }
  };
  

  return (
    <Modal
        open={visivel}
        title="Notificação – Perícia Médica de Reavaliação"
        width={720}
        closable={true}         
        maskClosable={false}       
        keyboard={false}             
        footer={[
          <Button
            key="print"
            icon={<PrinterOutlined />}
            onClick={handleImprimir}
          >
            Imprimir
          </Button>,
          <Button key="close" type="primary" onClick={onFechar}>
            Fechar
          </Button>,
        ]}
        onCancel={onFechar}     
    >
      <div style={{ padding: "8px 4px" }}>
        {mensagem?.includes("·") || mensagem?.includes("-") ? (
          <ul style={{ paddingLeft: 20 }}>
            {formatarMensagem(mensagem)}
          </ul>
        ) : (
          formatarMensagem(mensagem)
        )}
      </div>
    </Modal>
  );
};

export default BloqueioJuntaMedica;
